import { useNavigate, useLocation, useParams } from 'react-router-dom';

import useAuth from '../hooks/useAuth';

import Header from './Header'
import Knoppie from './Knoppie'
import Employees from'../../src/images/Employees.png'
import Injuries from'../../src/images/Injuries.png'
import NoImage from'../../src/images/no-image.png'
import PayrollImage from '../../src/images/payroll.png';
import Time from '../../src/images/clock_10208216.png';


const PayrollIndex = () =>{
    const location = useLocation();
    const auth = useAuth();
        const username = auth.auth.user.username
        const access = auth.auth.user.userRole
        const from = location.state?.from || './'
    return (
        <>
        <Header username={username} role={access} destination={from}></Header>
        <div>Payroll Index</div>
        {access==="administrator"||"manager"?
        (
        <>
        <Knoppie
        clickable={true}
        image={Employees}
        text={"Employees List"}
        destination={"../EmployeeList"}
        
        />
        <Knoppie
        clickable={true}
        image={PayrollImage}
        text={"Create new Payrun"}
        destination={"../PayrunList"}
        
        />
         <Knoppie
        clickable={true}
        image={Time}
        text={"Time Attendance"}
        destination={"../TimeAttendanceIndex"}
        
        />


        <Knoppie
        clickable={true}
        image={Injuries}
        text={"Injuries List"}
        destination={"../InjuriesList"}
        
        />
        <Knoppie
        clickable={true}
        image={NoImage}
        text={"Settings"}
        from={'./Payroll'}
        destination={"../PayrollSettings"}
        
        />
        <Knoppie
        clickable={true}
        image={NoImage}
        text={"Payroll transactions"}
        destination={"../PayrollTransactionsList"}
        
        />
       
    </>
    ):
        ("")}



        </>
    )

}

export default PayrollIndex